import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2023project/q1/2023economics/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};
const getVoteList = (type: any, page: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      awards: type,
      page,
    },
  });
};
const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
const getNews = (page: any, classId: any) => {
  return http.get(`/v1/news/topicList?page=${page}&classId=${classId}`);
};

const getRules = (type: any) => {
  const data: any = {
    1: `<p>为全面贯彻落实习近平新时代中国特色社会主义思想和党的二十大、中央经济工作会以及市委六届二次会议、全市经济工作会议精神，发挥党报集团主流媒体舆论引导作用，激发市场主体活力，弘扬企业家精神，重报集团继续携手两江新区管委会共同主办2022“十大重庆经济年度人物、十大两江新区经济年度人物”评选活动。</p>
  <p>本次评选将着力展现新时代新征程全面建设社会主义现代化新重庆，推动高质量发展取得的新成就，推动人民生活水平显著提升的新作为，挖掘、宣传在先进制造业、现代服务业、现代农业、数字经济等领域做出积极贡献和显著成绩的领军人物和优秀案例。通过本次评选，为推动成渝地区双城经济圈建设、加快建设西部陆海新通道、重庆高质量发展营造良好舆论氛围。</p>`,
      2: `<p>1.指导单位</p>
<p>重庆市委组织部、重庆市委宣传部、重庆市委统战部</p>
<p>2.主办单位</p>
<p>重庆日报报业集团、重庆两江新区管委会</p>
<p>3.承办单位</p>
<p>上游新闻、两江新区党工委宣传部</p>
<p>4.协办单位</p>
<p>华龙网集团</p>
<p>5.组委会成员单位</p>
<p>重庆市发展改革委、重庆市科技局、重庆市经济信息委、重庆市人力社保局、重庆市规划自然资源局、重庆市住房城乡建委、重庆市城市管理局、重庆市交通局、重庆市农业农村委、重庆市商务委、重庆市文化旅游委、重庆市国资委、重庆市金融监管局、重庆市大数据发展局、重庆市工商联</p>
<p>6.官方媒体</p>
<p>上游新闻、重庆日报、华龙网、重庆晚报、重庆晨报、两江新区融媒体中心</p>`,
    3: `
<p>（一）人物类</p>
<p>2022十大重庆经济年度人物</p>
<p>2022重庆经济年度创新人物</p>
<p>2022十大两江新区经济年度人物</p>
<p>（二）案例类</p>
<p>2022十大成渝地区双城经济圈协同发展创新案例</p><p>2022十大重庆经济改革创新案例</p>`,
    4: `<p><strong>1.人物类</strong></p>
<p>（1）基本要求</p>
<p>① 参评人遵守国家法律，坚持正确政治方向，践行社会主义核心价值观，具有良好的职业道德和行业声誉；</p>
<p>② 参评人在爱国、创新、诚信、社会责任和国际视野等方面不断提升自己，推动企业发挥更大作用实现更大发展；</p>
<p>③ 参评人及所在单位具备良好的风险管控能力，无不良会计信用、纳税信用和银行信用记录及其他严重违规违法行为，所在单位近三年内无重大安全、质量、环境污染事故发生；</p>
<p>④ 参评人2022全年度在同一单位担任董事长、总裁或总经理等主要领导职务；</p>
<p>⑤“十大重庆经济年度人物”奖项和“重庆经济年度创新人物”奖项不得重复报名。</p>
<p>（2）奖项要求</p>
<p>①“十大重庆经济年度人物”参评人所在单位是在重庆注册的法人企业并开展业务，企业注册时间为2020年1月1日前，近三年保持盈利，在创造产值、税收贡献、扩大就业、行业引领、产业升级等方面有突出表现。工业企业2022年主营收入5亿元以上，纳税金额3000万元以上，就业人数300人以上，实现增加值1亿元以上。农业、服务业企业2022年主营收入2亿元以上，纳税金额300万元以上，就业人数200人以上。</p>
<p>②“重庆经济年度创新人物”参评人所在单位是在重庆注册的法人企业并开展业务，企业注册时间为2022年1月1日前，企业规模为中小微企业，在业态创新、数字化运营、模式创新、技术创新等方面有突出表现。2022年营业收入2000万元以上。年度研发经费投入不低于100万元，研发经费投入强度不低于3%，农业、非高技术服务业创新企业，曾参与行业标准制定或具有核心技术发明专利，可适当放宽研发经费投入条件。</p>
<p>③“十大两江新区经济年度人物”参评人所在单位是在两江新区注册的法人企业并开展业务，企业注册时间为2022年1月1日前，在加快构建现代化产业体系、提升科技创新支撑能力、提振信心加快扩大内需、持续加力推进改革开放、着力推动区域协调发展、持续推动营商环境优化、加快推动城市品质提升等方面在两江新区及重庆有突出表现。2022年营业收入1亿元以上，纳税金额500万元以上，就业人数100人以上。</p>
<p><strong>2.案例类</strong></p>
<p>（1）“十大成渝地区双城经济圈协同发展创新案例”参评项目，在聚焦目标任务，抓好“十项行动”和重点任务清单，推动成渝地区双城经济圈建设走深走实，在共建具有全国影响力的科技创新中心、共建西部金融中心、打造具有巴蜀特色的国际消费目的地、共筑长江上游生态屏障、联手打造内陆改革开放高地、深入推动城乡融合发展、强化公共服务共建共享等方面涌现出的新机制、新模式、新成果。</p>
<p>（2）“十大重庆经济改革创新案例”参评项目，在加快推动重庆高质量发展中，推进重要领域和关键环节改革创新突破、落地见效，聚焦国资国企改革、民营企业改革、农业农村改革、财政金融改革、营商环境创新，以及数字经济、产业升级、科技创新等方面涌现出的可复制推广的新机制、新模式、新成果。</p>`,
    5: `<p>1.经济贡献力</p>
<p>2.创新变革力</p>
<p>3.行业带动力</p>
<p>4.持续发展力</p>
<p>5.社会影响力</p>`,
    6: `<p>1． 推荐报名（3月-4月）</p>
<p style="text-align: left;">备注：每5年（2020—2024年）为一个参评周期，5年内相同奖项只获评一次。</p>
<p>2．入围审查（5月）</p>
<p>3．公众点赞（5月）</p>
<p>4．专家评审（6月）</p>
<p>5．审定发布（6月）</p>
<p>6．表彰颁奖（9月）</p>`,
  };
  return data[type];
};
// 人物
const vote = (page: number, search: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_vote/controller.php?enews=vote-list&search=${search}&page=${page}`,
  );
};
// 案例
const caseVote = (page: number, search: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_case_vote/controller.php?enews=vote-list&search=${search}&page=${page}`,
  );
};
const voteDetail = (id: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_vote/controller.php?enews=detail&id=${id}`,
  );
};
const caseDetail = (id: string) => {
  return http.get(
    `vote/2022project/q2/2022economics_case_vote/controller.php?enews=detail&id=${id}`,
  );
};
export {
  getBaseInfo,
  getVoteList,
  getRules,
  getDetail,
  getNews,
  vote,
  caseVote,
  voteDetail,
  caseDetail,
};
